import { API } from 'api';
import { AxiosResponse } from 'axios';
import { IProvidersRequest, IProvidersResponse, IUtilityProvidersRequest, IUtilityProvidersResponse } from 'types';
import { API_URL } from 'utils/enums';

class ProvidersService {
	static getProviders = async (reqBody: IProvidersRequest): Promise<AxiosResponse<IProvidersResponse>> =>
		API.post(API_URL.PROVIDERS_LIST_GET, reqBody);

	static getUtilityProviders = async (
		reqBody: IUtilityProvidersRequest
	): Promise<AxiosResponse<IUtilityProvidersResponse>> => API.post(API_URL.UTILITY_PROVIDERS_LIST_GET, reqBody);
}

export { ProvidersService };
